import React from "react";
import './assets/loader.css'

const Loader = (props) => {
  return (
      <div className="bouncing-loader">
        <div></div>
        <div></div>
        <div></div>
      </div>
  );
};

export default Loader;